import { render, staticRenderFns } from "./Integrationbox.vue?vue&type=template&id=2a7f4335&scoped=true&"
import script from "./Integrationbox.vue?vue&type=script&lang=js&"
export * from "./Integrationbox.vue?vue&type=script&lang=js&"
import style0 from "./Integrationbox.vue?vue&type=style&index=0&id=2a7f4335&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f4335",
  null
  
)

export default component.exports